import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatBotAuthorizeService {
  private token: string | null = null;
  private tokenExpiration: number | null = null;  // Momento de expiración del token (timestamp)
  private authTokenSource = new BehaviorSubject<string | null>(null);

  constructor(private http: HttpClient) {
    this.loadTokenFromStorage();
  }

  // Método para obtener el token desde un endpoint específico o de cache
  getToken(): Observable<string> {
    // Si el token ya está disponible y no ha caducado, devolverlo directamente
    if (this.token && this.tokenExpiration && Date.now() < this.tokenExpiration) {
      return new BehaviorSubject<string>(this.token).asObservable();
    } else {
      // De lo contrario, solicitar un nuevo token
      return this.http.get<{ access_token: string, expires_in: number }>(environment.api + '/token', {}).pipe(
        tap(response => {
          this.setToken(response.access_token, response.expires_in);
        }),
        // Transformar la respuesta para devolver solo el token como un Observable<string>
        map(response => response.access_token)
      );
    }
  }

  // Método para establecer el token y su tiempo de expiración
  private setToken(token: string, expiresIn: number): void {
    this.token = token;
    this.tokenExpiration = Date.now() + expiresIn * 1000; // Guardar el tiempo de expiración (convertido a milisegundos)

    // Guardar en localStorage
    localStorage.setItem('ChatBotToken', token);
    localStorage.setItem('ChatBotTokenExpiration', this.tokenExpiration.toString());

    // Notificar a los suscriptores
    this.authTokenSource.next(token);
  }

  // Método para cargar el token desde el localStorage (si existe y es válido)
  private loadTokenFromStorage(): void {
    const storedToken = localStorage.getItem('ChatBotToken');
    const storedExpiration = localStorage.getItem('ChatBotTokenExpiration');

    if (storedToken && storedExpiration) {
      const expiration = parseInt(storedExpiration, 10);
      if (Date.now() < expiration) {
        this.token = storedToken;
        this.tokenExpiration = expiration;
        this.authTokenSource.next(this.token);
      }
    }
  }
}
